import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import * as Quill from "quill";
import axios from "axios";
import { formRules } from "@/js/form_rules.js";
import { request } from "@/js/http/http_request";
import { orderTypes, purchaseOrder } from "@/js/lists.ts";
export default {
  components: {
    UploaderV2: function UploaderV2() {
      return import("@/components/default/UploaderV2.vue");
    }
  },
  props: {
    value: {
      type: Object,
      default: {
        sendTo: [],
        files: []
      }
    },
    documents: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    "no-files": {
      type: Boolean,
      default: false
    },
    "no-uploader": {
      type: Boolean,
      default: false
    },
    withRelatedFiles: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: null
    },
    inboundDelivery: {
      type: Object,
      default: null
    },
    user: {
      type: Object,
      default: null
    },
    purchaseOrder: {
      type: Object,
      default: null
    },
    placeholders: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isDeletingTemplate: {
      type: Boolean,
      default: false
    },
    templates: {
      type: Array
    },
    templateRequired: {
      type: Boolean,
      default: true
    }
  },
  data: function data(_this) {
    return {
      quill: {},
      hasContentError: false,
      isInsertingContent: false,
      lastFocus: null,
      items: [{
        text: "My Files",
        icon: "mdi-folder"
      }, {
        text: "Shared with me",
        icon: "mdi-account-multiple"
      }, {
        text: "Starred",
        icon: "mdi-star"
      }, {
        text: "Recent",
        icon: "mdi-history"
      }, {
        text: "Offline",
        icon: "mdi-check-circle"
      }, {
        text: "Uploads",
        icon: "mdi-upload"
      }, {
        text: "Backups",
        icon: "mdi-cloud-upload"
      }],
      form: {
        valid: false
      },
      selectedDocuments: [],
      selectedItem: 0,
      placeholdersShown: false,
      loadings: {
        isLoadingOrderFiles: false,
        isLoadingWineFiles: false,
        isLoadingWineryFiles: false,
        isLoadingPurchaseOrderFiles: false,
        isLoadingPurchaseOrderRelatedFiles: false
      },
      isOrderOrInbound: false,
      isUser: false,
      isPurchaseOrder: false,
      orderDocuments: [],
      wineDocuments: [],
      wineryDocuments: [],
      wineFilesPanels: [],
      wineryFilesPanels: [],
      purchaseOrderGlobalDocuments: [],
      purchaseOrderRelatedDocuments: [],
      rules: formRules
    };
  },
  created: function created() {
    var _this2 = this;
    this.selectedDocuments = this.documents.filter(function (x) {
      return _this2.model.files.filter(function (f) {
        return !!f.blob;
      }).some(function (f) {
        var _x$document_urls$;
        return ((_x$document_urls$ = x.document_urls[0]) === null || _x$document_urls$ === void 0 ? void 0 : _x$document_urls$.name) === f.id;
      });
    });
    if (!!this.order || !!this.inboundDelivery) {
      this.isOrderOrInbound = true;
    }
    if (!!this.user) {
      this.isUser = true;
    }
    if (!!this.purchaseOrder) {
      this.isPurchaseOrder = true;
    }
    if (this.withRelatedFiles && !!this.order) {
      if (!this.isOrderServiceInvoice) {
        this.fetchOrderDocuments();
        this.fetchWineDocuments();
        this.fetchWineryDocuments();
      }
    }
    if (this.withRelatedFiles && !!this.inboundDelivery) {
      this.fetchInboundDocuments();
      this.fetchInboundWineDocuments();
      this.fetchInboundWineryDocuments();
    }
    if (this.withRelatedFiles && !!this.purchaseOrder) {
      this.fetchPurchaseOrderGlobalDocuments();
      this.fetchPurchaseOrderRelatedDocuments();
    }
  },
  mounted: function mounted() {
    this.quill = new Quill("#editor_".concat(this.$vnode.key), {
      modules: {
        toolbar: "#toolbar_".concat(this.$vnode.key)
      },
      theme: "snow"
    });
    var _this = this;
    document.getElementById("custom-button_".concat(this.$vnode.key)).addEventListener("click", function () {
      _this.placeholdersShown = !_this.placeholdersShown;
    });
    this.quill.on("text-change", function () {
      _this.$nextTick(function () {
        _this.model.htmlContent = _this.quill.root.innerHTML;
        _this.onModelUpdate();
      });
    });
    this.quill.on("selection-change", function (value) {
      _this.isInsertingContent = !!value;
      _this.lastFocus = "quill";
    });
    var delta = this.quill.clipboard.convert(this.model.htmlContent);
    this.quill.setContents(delta, "silent");
  },
  watch: {
    "model.htmlContent": function modelHtmlContent(newVal) {
      if (!this.isInsertingContent) {
        var delta = this.quill.clipboard.convert(newVal);
        this.quill.setContents(delta, "silent");
      }
    }
  },
  computed: {
    isEditing: function isEditing() {
      return !!this.templates;
    },
    model: {
      get: function get() {
        return _objectSpread({}, this.value);
      },
      set: function set(value) {
        if (Object.isObject(value)) {
          this.$emit("input", _objectSpread({}, value));
        } else {
          this.$emit("input", _objectSpread({}, this.value));
        }
      }
    },
    isOrderServiceInvoice: function isOrderServiceInvoice() {
      var _this$order;
      return ((_this$order = this.order) === null || _this$order === void 0 ? void 0 : _this$order.type) == orderTypes.STANDALONE;
    },
    placeholdersReady: function placeholdersReady() {
      var p = this.placeholders;
      return p && Array.isArray(p.Customer) && Array.isArray(p.Merchant) && Array.isArray(p.Order) && Array.isArray(p.PurchaseOrder);
    }
  },
  methods: {
    validateHtmlContent: function validateHtmlContent() {
      this.hasContentError = !this.model.htmlContent;
      return !this.hasContentError;
    },
    syncFiles: function syncFiles(files) {
      this.model = _objectSpread(_objectSpread({}, this.model), {}, {
        files: [].concat(_toConsumableArray(this.model.files.filter(function (x) {
          return !!x.blob;
        })), _toConsumableArray(files))
      });
    },
    clickPlaceholder: function clickPlaceholder(item) {
      var _this3 = this;
      this.$emit("click:placeholder", item, function (value) {
        //Management for TrackingNumber (or global links, to not see the URL, transform in clickable link)
        var urlLink = null;
        var regexpLinkDetector = /^<a(.+)href=["'](.+)["'](.*)>(.+)<\/a>$/;
        if (regexpLinkDetector.test(value)) {
          var array = regexpLinkDetector.exec(value);
          urlLink = array[2];
          value = array[4];
        }
        value = value.replace(/<br\s*\/?>/gi, "\n");
        if (_this3.lastFocus === "quill") {
          var caretPosition = _this3.quill.getSelection(true);
          _this3.quill.insertText(caretPosition, value, "user");
          if (!!urlLink) {
            _this3.quill.setSelection(caretPosition.index, value.length);
            _this3.quill.theme.tooltip.edit("link", urlLink);
            _this3.quill.theme.tooltip.save();
          }
          _this3.$nextTick(function () {
            return _this3.onModelUpdate();
          });
        } else {
          var input = _this3.$refs.subject.$refs.input;
          var sentence = input.value;
          var len = sentence.length;
          var pos = input.selectionStart;
          var before = sentence.substr(0, pos);
          var after = sentence.substr(pos, len);
          _this3.model.subject = before + value + after;
          _this3.$nextTick().then(function () {
            input.selectionStart = pos + value.length;
            _this3.onModelUpdate();
          });
        }
      });
      this.placeholdersShown = false;
    },
    XMLHttpRequestBlob: function XMLHttpRequestBlob(url) {
      return new Promise(function (resolve, reject) {
        var req = new XMLHttpRequest();
        req.responseType = "blob";
        req.onload = function () {
          return resolve(req.response);
        };
        req.onerror = function () {
          return reject(new Error("GET ".concat(url, " failed")));
        };
        req.open("GET", url);
        req.send();
      });
    },
    inputDocuments: function inputDocuments() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, downloadPromises, results, newFiles;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this4;
              _this4.$emit("documentLoading", true);
              _this.model = _objectSpread(_objectSpread({}, _this.model), {}, {
                files: _this.model.files.filter(function (f) {
                  return !f.blob;
                })
              });
              downloadPromises = [];
              _this4.selectedDocuments.forEach(function (doc) {
                doc.document_urls.forEach(function (item) {
                  downloadPromises.push(_this4.XMLHttpRequestBlob(item.url).then(function (blob) {
                    return {
                      item: item,
                      blob: blob
                    };
                  }));
                });
              });
              _context.prev = 5;
              if (!(downloadPromises.length === 0)) {
                _context.next = 12;
                break;
              }
              _this.model = _objectSpread(_objectSpread({}, _this.model), {}, {
                files: []
              });
              _this4.$nextTick(function () {
                _this4.$emit("documentLoading", false);
              });
              return _context.abrupt("return");
            case 12:
              _context.next = 14;
              return Promise.all(downloadPromises);
            case 14:
              results = _context.sent;
              newFiles = results.map(function (_ref) {
                var item = _ref.item,
                  blob = _ref.blob;
                return {
                  id: item.name,
                  url: item.url,
                  blob: blob
                };
              });
              _this.model = _objectSpread(_objectSpread({}, _this.model), {}, {
                files: [].concat(_toConsumableArray(_this.model.files.filter(function (f) {
                  return !f.blob;
                })), _toConsumableArray(newFiles))
              });
            case 17:
              _context.prev = 17;
              _this4.$nextTick(function () {
                _this4.$emit("documentLoading", false);
              });
              return _context.finish(17);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[5,, 17, 20]]);
      }))();
    },
    clickOutsidePlaceholders: function clickOutsidePlaceholders() {
      this.placeholdersShown = false;
    },
    editTemplate: function editTemplate(templateId) {
      this.$emit("edit", templateId);
    },
    deleteTemplate: function deleteTemplate(templateId) {
      this.$emit("delete", templateId);
    },
    newTemplate: function newTemplate() {
      this.$emit("click:new");
    },
    changeTemplate: function changeTemplate(template) {
      if (Object.isObject(template)) {
        this.selectedDocuments = [];
        this.$emit("input", template);
        this.$emit("change", template);
      }
    },
    onModelUpdate: function onModelUpdate() {
      this.$emit("input", this.model);
    },
    fetchOrderDocuments: function fetchOrderDocuments() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this5;
              _this5.loadings.isLoadingOrderFiles = true;
              _context2.next = 4;
              return request("/v1/order/".concat(_this.order.id_order, "/files"), "get", null, true, "api", null, _this5.filesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.isLoadingOrderFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context2.sent;
              if (response) _this5.orderDocuments = _toConsumableArray(response.data);
              _this5.orderDocuments = _this5.orderDocuments.map(function (doc, index) {
                var filename = doc.filename.replace(/ /g, "");
                return {
                  id: index,
                  name: filename,
                  document_urls: [{
                    url: doc.url,
                    name: filename
                  }],
                  children: [{
                    url: doc.url,
                    name: filename
                  }],
                  tag: doc.tag,
                  doc_provenance: "globalOrder"
                };
              });
              _this5.loadings.isLoadingOrderFiles = false;
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchWineDocuments: function fetchWineDocuments() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response, winesFromDocuments, ids;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this6;
              _this6.loadings.isLoadingWineFiles = true;
              _context3.next = 4;
              return request("/v1/order/".concat(_this.order.id_order, "/files/wines"), "post", {
                items: _this6.order.items,
                searchLabel: null,
                documentTags: []
              }, true, "api", null, _this6.filesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.loadings.isLoadingWineFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context3.sent;
              if (response) _this6.wineDocuments = _toConsumableArray(response.data);
              _this6.wineDocuments = _this6.wineDocuments.map(function (doc, index) {
                var filename = doc.filename.replace(/ /g, "");
                return {
                  id: index,
                  name: filename,
                  document_urls: [{
                    url: doc.url,
                    name: filename
                  }],
                  children: [{
                    url: doc.url,
                    name: filename
                  }],
                  tag: doc.tag,
                  wine: {
                    id: doc.wine.id_wine,
                    name: doc.wine.display_name
                  },
                  doc_provenance: "wine"
                };
              });
              winesFromDocuments = _this6.wineDocuments.map(function (doc, index) {
                return {
                  id: doc.wine.id,
                  name: doc.wine.name,
                  files: _this6.wineDocuments.filter(function (x) {
                    return x.wine.id === doc.wine.id;
                  })
                };
              });
              ids = winesFromDocuments.map(function (o) {
                return o.id;
              });
              _this6.wineDocuments = winesFromDocuments.filter(function (_ref2, index) {
                var id = _ref2.id;
                return !ids.includes(id, index + 1);
              });
              _this6.loadings.isLoadingWineFiles = false;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchWineryDocuments: function fetchWineryDocuments() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, response, wineriesFromDocuments, ids;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this7;
              _this7.loadings.isLoadingWineryFiles = true;
              _context4.next = 4;
              return request("/v1/order/".concat(_this.order.id_order, "/files/wineries"), "post", {
                items: _this7.order.items,
                searchLabel: null,
                documentTags: []
              }, true, "api", null, _this7.filesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.loadings.isLoadingWineryFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context4.sent;
              if (response) _this7.wineryDocuments = _toConsumableArray(response.data);
              _this7.wineryDocuments = _this7.wineryDocuments.map(function (doc, index) {
                var filename = doc.filename.replace(/ /g, "");
                return {
                  id: index,
                  name: filename,
                  document_urls: [{
                    url: doc.url,
                    name: filename
                  }],
                  children: [{
                    url: doc.url,
                    name: filename
                  }],
                  tag: doc.tag,
                  winery: {
                    id: doc.winery.id,
                    name: doc.winery.name
                  },
                  doc_provenance: "winery"
                };
              });
              wineriesFromDocuments = _this7.wineryDocuments.map(function (doc, index) {
                return {
                  id: doc.winery.id,
                  name: doc.winery.name,
                  files: _this7.wineryDocuments.filter(function (x) {
                    return x.winery.id === doc.winery.id;
                  })
                };
              });
              ids = wineriesFromDocuments.map(function (o) {
                return o.id;
              });
              _this7.wineryDocuments = wineriesFromDocuments.filter(function (_ref3, index) {
                var id = _ref3.id;
                return !ids.includes(id, index + 1);
              });
              _this7.loadings.isLoadingWineryFiles = false;
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchInboundDocuments: function fetchInboundDocuments() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this = _this8;
              _this8.loadings.isLoadingOrderFiles = true;
              _context5.next = 4;
              return request("/v1/inbound/delivery/".concat(_this.inboundDelivery.id, "/files"), "get", null, true, "api", null).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.isLoadingOrderFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context5.sent;
              if (response) _this8.orderDocuments = _toConsumableArray(response.data.value);
              _this8.orderDocuments = _this8.orderDocuments.map(function (doc, index) {
                var filename = doc.filename.replace(/ /g, "");
                return {
                  id: index,
                  name: filename,
                  document_urls: [{
                    url: doc.url,
                    name: filename
                  }],
                  children: [{
                    url: doc.url,
                    name: filename
                  }],
                  tag: doc.tag,
                  doc_provenance: "globalOrder"
                };
              });
              _this8.loadings.isLoadingOrderFiles = false;
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    fetchInboundWineDocuments: function fetchInboundWineDocuments() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this, response, winesFromDocuments, ids;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this = _this9;
              _this9.loadings.isLoadingWineFiles = true;
              _context6.next = 4;
              return request("/v1/inbound/delivery/".concat(_this.inboundDelivery.id, "/files/wines"), "post", {
                items: _this9.inboundDelivery.items,
                searchLabel: null,
                documentTags: []
              }, true, "api", null).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.loadings.isLoadingWineFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context6.sent;
              if (response) _this9.wineDocuments = _toConsumableArray(response.data.value);
              _this9.wineDocuments = _this9.wineDocuments.map(function (doc, index) {
                var filename = doc.filename.replace(/ /g, "");
                return {
                  id: index,
                  name: filename,
                  document_urls: [{
                    url: doc.url,
                    name: filename
                  }],
                  children: [{
                    url: doc.url,
                    name: filename
                  }],
                  tag: doc.tag,
                  wine: {
                    id: doc.wine.id_wine,
                    name: doc.wine.display_name
                  },
                  doc_provenance: "wine"
                };
              });
              winesFromDocuments = _this9.wineDocuments.map(function (doc, index) {
                return {
                  id: doc.wine.id,
                  name: doc.wine.name,
                  files: _this9.wineDocuments.filter(function (x) {
                    return x.wine.id === doc.wine.id;
                  })
                };
              });
              ids = winesFromDocuments.map(function (o) {
                return o.id;
              });
              _this9.wineDocuments = winesFromDocuments.filter(function (_ref4, index) {
                var id = _ref4.id;
                return !ids.includes(id, index + 1);
              });
              _this9.loadings.isLoadingWineFiles = false;
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    fetchInboundWineryDocuments: function fetchInboundWineryDocuments() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this, response, wineriesFromDocuments, ids;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this = _this10;
              _this10.loadings.isLoadingWineryFiles = true;
              _context7.next = 4;
              return request("/v1/inbound/delivery/".concat(_this.inboundDelivery.id, "/files/wineries"), "post", {
                items: _this10.inboundDelivery.items,
                searchLabel: null,
                documentTags: []
              }, true, "api", null, _this10.filesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.loadings.loadings.isLoadingWineryFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context7.sent;
              if (response) _this10.wineryDocuments = _toConsumableArray(response.data.value);
              _this10.wineryDocuments = _this10.wineryDocuments.map(function (doc, index) {
                var filename = doc.filename.replace(/ /g, "");
                return {
                  id: index,
                  name: filename,
                  document_urls: [{
                    url: doc.url,
                    name: filename
                  }],
                  children: [{
                    url: doc.url,
                    name: filename
                  }],
                  tag: doc.tag,
                  winery: {
                    id: doc.winery.id,
                    name: doc.winery.name
                  },
                  doc_provenance: "winery"
                };
              });
              wineriesFromDocuments = _this10.wineryDocuments.map(function (doc, index) {
                return {
                  id: doc.winery.id,
                  name: doc.winery.name,
                  files: _this10.wineryDocuments.filter(function (x) {
                    return x.winery.id === doc.winery.id;
                  })
                };
              });
              ids = wineriesFromDocuments.map(function (o) {
                return o.id;
              });
              _this10.wineryDocuments = wineriesFromDocuments.filter(function (_ref5, index) {
                var id = _ref5.id;
                return !ids.includes(id, index + 1);
              });
              _this10.loadings.isLoadingWineryFiles = false;
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    fetchPurchaseOrderGlobalDocuments: function fetchPurchaseOrderGlobalDocuments() {
      var _this = this;
      this.loadings.isLoadingPurchaseOrderFiles = true;
      request("/v1/purchase-orders/".concat(_this.purchaseOrder.id, "/files/po"), "get", null, true, "api", null, this.filesCancelToken).then(function (response) {
        console.log("response", response);
        if (response) {
          _this.purchaseOrderGlobalDocuments = [].concat(_toConsumableArray(_this.purchaseOrderGlobalDocuments), [response.data]);
        }
        _this.purchaseOrderGlobalDocuments = _this.purchaseOrderGlobalDocuments.map(function (doc, index) {
          var filename = doc.filename.replace(/ /g, "");
          return {
            id: index,
            name: filename,
            document_urls: [{
              url: doc.url,
              name: filename
            }],
            children: [{
              url: doc.url,
              name: filename
            }],
            tag: doc.tag,
            doc_provenance: "purchaseOrderGlobal"
          };
        });
      }).catch(function (e) {
        if (!axios.isCancel(e)) {
          _this.$toasted.show("Unable to load files.", {
            type: "error"
          });
          throw e;
        }
      }).finally(function () {
        _this.loadings.isLoadingPurchaseOrderFiles = false;
      });
    },
    fetchPurchaseOrderRelatedDocuments: function fetchPurchaseOrderRelatedDocuments() {
      var _this = this;
      this.loadings.isLoadingPurchaseOrderRelatedFiles = true;
      request("/v1/purchase-orders/".concat(_this.purchaseOrder.id, "/files"), "get", null, true, "api", null, this.filesCancelToken).then(function (response) {
        if (response) _this.purchaseOrderRelatedDocuments = _toConsumableArray(response.data);
        _this.purchaseOrderRelatedDocuments = _this.purchaseOrderRelatedDocuments.map(function (doc, index) {
          var filename = doc.filename.replace(/ /g, "");
          return {
            id: index,
            name: filename,
            document_urls: [{
              url: doc.url,
              name: filename
            }],
            children: [{
              url: doc.url,
              name: filename
            }],
            tag: doc.tag,
            doc_provenance: "purchaseOrder"
          };
        });
      }).catch(function (e) {
        if (!axios.isCancel(e)) {
          _this.$toasted.show("Unable to load files.", {
            type: "error"
          });
          throw e;
        }
      }).finally(function () {
        _this.loadings.isLoadingPurchaseOrderRelatedFiles = false;
      });
    },
    selectAllGlobalOrderFiles: function selectAllGlobalOrderFiles() {
      this.selectedDocuments = this.selectedDocuments.filter(function (x) {
        return x.doc_provenance !== "globalOrder";
      });
      this.selectedDocuments = [].concat(_toConsumableArray(this.selectedDocuments), _toConsumableArray(this.orderDocuments));
      this.inputDocuments();
    },
    selectAllWineFiles: function selectAllWineFiles() {
      var _this11 = this;
      this.wineFilesPanels = [];
      this.selectedDocuments = this.selectedDocuments.filter(function (x) {
        return x.doc_provenance !== "wine";
      });
      this.wineDocuments.forEach(function (wine, index) {
        wine.files.forEach(function (file) {
          _this11.selectedDocuments.push(file);
        });
        _this11.wineFilesPanels.push(index);
      });
      this.inputDocuments();
    },
    selectAllWineryFiles: function selectAllWineryFiles() {
      var _this12 = this;
      this.wineryFilesPanels = [];
      this.selectedDocuments = this.selectedDocuments.filter(function (x) {
        return x.doc_provenance !== "winery";
      });
      this.wineryDocuments.forEach(function (winery, index) {
        winery.files.forEach(function (file) {
          _this12.selectedDocuments.push(file);
        });
        _this12.wineryFilesPanels.push(index);
      });
      this.inputDocuments();
    },
    selectAllPurchaseOrderRelatedFiles: function selectAllPurchaseOrderRelatedFiles() {
      this.selectedDocuments = this.selectedDocuments.filter(function (x) {
        return x.doc_provenance !== "purchaseOrder";
      });
      this.selectedDocuments = [].concat(_toConsumableArray(this.selectedDocuments), _toConsumableArray(this.purchaseOrderRelatedDocuments));
      this.inputDocuments();
    },
    selectAllGlobalPurchaseOrderFiles: function selectAllGlobalPurchaseOrderFiles() {
      this.selectedDocuments = this.selectedDocuments.filter(function (x) {
        return x.doc_provenance !== "purchaseOrder";
      });
      this.selectedDocuments = [].concat(_toConsumableArray(this.selectedDocuments), _toConsumableArray(this.purchaseOrderGlobalDocuments));
      this.inputDocuments();
    }
  }
};